/**
 * Brand Grid — autoplay del carrusel móvil.
 *
 * Extraído del <script> inline de sections/brand-grid.liquid para que se cachee
 * en vez de re-descargarse con cada respuesta HTML (la sección vive en 18 plantillas).
 *
 * La lógica es idéntica a la original; solo cambia el arranque: en vez de recibir
 * un section.id interpolado por Liquid, descubre los contenedores por sí mismo.
 */
(function () {
  // La sección puede aparecer varias veces en una página y cada instancia emite
  // su propio <script src>. Sin esta guarda, el navegador ejecutaría el archivo
  // una vez por instancia y se duplicarían los listeners.
  if (window.__brandGridLoaded) return;
  window.__brandGridLoaded = true;

  function initBrandGridSlider(container) {
    if (!container || container.dataset.brandGridInit === 'true') return;
    container.dataset.brandGridInit = 'true';

    const autoplayEnabled = container.dataset.autoplay === 'true';
    const autoplaySpeed = parseInt(container.dataset.autoplaySpeed, 10) * 1000 || 4000;
    const isMobileCarousel = container.dataset.mobileCarousel === 'true';

    let intervalId = null;

    function getNextScrollPosition() {
      const items = Array.from(container.querySelectorAll('.brand-grid__item'));
      if (items.length === 0) return 0;

      const containerScrollLeft = container.scrollLeft;
      const containerWidth = container.clientWidth;

      // Get unique, sorted horizontal offsets (rounded to handle subpixel rendering differences)
      const offsetsSet = new Set();
      items.forEach((item) => {
        const relLeft = item.offsetLeft - container.offsetLeft;
        offsetsSet.add(Math.round(relLeft));
      });
      const offsets = Array.from(offsetsSet).sort((a, b) => a - b);
      if (offsets.length === 0) return 0;

      let currentOffsetIndex = 0;
      for (let i = 0; i < offsets.length; i++) {
        if (offsets[i] >= containerScrollLeft - 10) {
          currentOffsetIndex = i;
          break;
        }
      }

      let nextOffsetIndex = currentOffsetIndex + 1;
      if (nextOffsetIndex >= offsets.length || containerScrollLeft >= container.scrollWidth - containerWidth - 10) {
        nextOffsetIndex = 0;
      }

      const nextOffset = offsets[nextOffsetIndex];
      const containerPaddingLeft = parseFloat(window.getComputedStyle(container).paddingLeft) || 0;
      let scrollToX = nextOffset - containerPaddingLeft;

      if (scrollToX < 0) scrollToX = 0;
      return scrollToX;
    }

    function scrollToNext() {
      const nextPos = getNextScrollPosition();
      container.scrollTo({
        left: nextPos,
        behavior: 'smooth'
      });
    }

    function startAutoplay() {
      if (!autoplayEnabled) return;
      stopAutoplay();
      intervalId = setInterval(scrollToNext, autoplaySpeed);
    }

    function stopAutoplay() {
      if (intervalId) {
        clearInterval(intervalId);
        intervalId = null;
      }
    }

    function checkAndStart() {
      const isMobile = window.innerWidth < 768;
      if (isMobile && isMobileCarousel) {
        startAutoplay();
      } else {
        stopAutoplay();
      }
    }

    checkAndStart();

    window.addEventListener('resize', checkAndStart);

    let timeoutId = null;
    const handleInteraction = () => {
      stopAutoplay();
      if (timeoutId) clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        checkAndStart();
      }, 3000);
    };

    container.addEventListener('touchstart', handleInteraction, { passive: true });
    container.addEventListener('scroll', handleInteraction);
  }

  function initAll() {
    document.querySelectorAll('[id^="brand-grid-"] .brand-grid__container').forEach(initBrandGridSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // El editor de temas reemplaza el DOM de la sección, así que el contenedor nuevo
  // llega sin la marca brandGridInit y se inicializa igual que en la carga inicial.
  document.addEventListener('shopify:section:load', (event) => {
    const section = document.getElementById('brand-grid-' + event.detail.sectionId);
    if (!section) return;
    section.querySelectorAll('.brand-grid__container').forEach(initBrandGridSlider);
  });
})();
